/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
var e={headerSearchBox:`#header__search__searchBox`,productRefinementSearchBox:`#product-refinement-search-box`,hitContainer:`#search__hits ul`,emptyResultsContainer:`kanter-search-no-results`,widgetContainer:`#dynamic-widgets .drawer__content`,paginationContainer:`#pagination`,toolbarContainer:`#products-toolbar`};export{e as containerIds};